import { DropDownList } from "@progress/kendo-react-dropdowns";
import "@progress/kendo-theme-default/dist/all.css";
import styled from "styled-components";
import { Heading } from "../../common.styles";
import "./dropdown.css";



// Dropdown categories  
const categories = [
    { id: null, label: "All locations" },
    { id: "Hong Kong", label: "Hong Kong" },
    { id: "Others", label: "Others", filter: (it) => { return it !== `Hong Kong` } },
];

const StyledHeading = styled(Heading)`
    color: #e1001e;
`;

export const LocationDropDownList = ({
    category,
    setCategory,
    jobsList
}) => {
    const categories = [
        { id: null, label: "All locations" },
        ...jobsList.reduce((a,c) => {
            if (a.find(x=> x.id == c.location)) {
                return a
            } else {
                return [...a, {id: c.location, label: c.location}]
            }
        }, [])
    ];
    console.log('categories: ', jobsList)
    return (
        <section className="joinUs-filter-item">
            <form className="k-form">
                <StyledHeading className="text-40">Location</StyledHeading>
                <DropDownList value={(category || categories[0]).label} data={categories.map((it) => { return it.label })} onChange={e => {
                    let selectedCategory = categories.filter((c) => {
                        return c.id != null
                            && c.label === e.value;
                    })
                    if (selectedCategory.length > 0) {
                        setCategory(selectedCategory[0])
                    } else {
                        setCategory(null);
                    }
                }} />
            </form>
        </section>
    );
};